import { createClient, SupabaseClient } from '@supabase/supabase-js';
import { Database } from '../types/database.types';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Faltam variáveis de ambiente do Supabase. Verifique o arquivo .env');
}

const getStorageType = () => {
  const rememberMe = localStorage.getItem('presida_remember_me');
  return rememberMe === 'true' ? 'local' : 'session';
};

export const supabase: SupabaseClient<Database> = createClient<Database>(
  supabaseUrl,
  supabaseAnonKey,
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      flowType: 'pkce',
      storage: {
        getItem: (key: string) => {
          const storageType = getStorageType();
          if (storageType === 'local') {
            return localStorage.getItem(key);
          } else {
            return sessionStorage.getItem(key);
          }
        },
        setItem: (key: string, value: string) => {
          const storageType = getStorageType();
          if (storageType === 'local') {
            localStorage.setItem(key, value);
          } else {
            sessionStorage.setItem(key, value);
          }
        },
        removeItem: (key: string) => {
          localStorage.removeItem(key);
          sessionStorage.removeItem(key);
        }
      }
    }
  }
);